import * as React from "react";
import bom from "src/assets/images/bom.png";
import print from "src/assets/images/print.png";
import exportimg from "src/assets/images/export.png";
import { useCartStore } from "src/hooks/cart";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import System from "src/helper/system";
import Constants from "src/helper/Constants";
import { useBOMStore } from "src/hooks/bom";
import liveAuth from "src/helper/liveAuth";
import Bom from "@system/config/bom";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";


const CartTools = (props) => {
  const [{ CART_DATA, CART_COUNT }, { }, { }, { export_cart_data }] = useCartStore();
  const [{ }, { }, { add_part_to_bom, create_bom, create_params_for_add_part_to_bom }] = useBOMStore();
  const [__check] = useAxiosIndicatorCheck();

  const openAddToBOM = async (e) => {
    if (liveAuth.check()) {
      let cartProd = [];
      Object.entries(CART_DATA).map((data, i) => {
        cartProd.push(data[1])
      })
      System.popup('AddToBOMPopup', { cartProduct: cartProd, fromCart: "yes", addFrom: Constants.systemModules.CART })

    } else {
      const guestBomID = localStorage.getItem(System.storageName.GUEST_BOM_ID)
      let params = await create_params_for_add_part_to_bom('', true)
      if (guestBomID) {
        const addPart = await add_part_to_bom(params)
        if (addPart?.data) {
          redirectToBOM(guestBomID);
        }
      } else {
        params.source = Constants.systemModules.CART
        const newBom = await create_bom(params);
        if (newBom?.data) {
          redirectToBOM(newBom.data);
        }
      }
    }

  };

  const redirectToBOM = (bomId) => {
    window.location.href = Bom.getBomDetailByIdRouteURL(
      bomId,
      {
        go: System.getParams().go
      }
    )
  };

  //By Ramya [Export Event - Cart ADobe script]
  function exportEvent(type) {
    localStorage.setItem("adobeEventType", "exportEvent");
    let exportDetails = {
      fileExtension: type,
      exportType: "Cart"
    }
    let prodDetails = CART_DATA;
    if (Object.keys(exportDetails).length && Object.keys(prodDetails).length) {
      HelperAdobeEvent.trackingAdobeEvent({ prodDetails, exportDetails });
    }

  }
  return (
    <>
      <div className="cart-tools">
        <h5 className="mt-0">CART TOOLS</h5>
        <hr className="mb-1" />
        <ul>
          <li>
            <a tabIndex={1} href={void 0} data-toggle="modal" data-target="#BomModal"
              className={"text-blue " + ((CART_COUNT === 0) ? 'link-disabled' : '')}
              onClick={() => openAddToBOM()}
            >
              <img src={bom} alt="Add to BOM" />
              <span>Add to BOM</span>
            </a>
          </li>
          {/**
           * based on cart_count disabled all links if cart is empty
           * Author: Devanshi Patel
           */}
          {/* {!__check(["CART_API_CALL", "CART_OPERATION_API_CALL"]).status && (
            <li className="dropdown">
              <a tabIndex={2} data-toggle="dropdown" aria-expanded="false"
                className={"text-blue " + ((!CART_COUNT || CART_COUNT <= 0) ? 'link-disabled' : '')}>
                <img src={exportimg} alt="Export" />
                <span>Export</span>
              </a>
              <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1"              >
                <li>
                  <a className="dropdown-item" tabIndex={3} href={void 0}
                    onClick={() => {
                      export_cart_data("csv");
                      exportEvent("csv");
                    }}> CSV</a>
                </li>
                <li>
                  <a className="dropdown-item"
                    onClick={() => {
                      export_cart_data("pdf");
                      exportEvent("pdf");
                    }} > PDF</a>
                </li>
              </ul>
            </li>
          )} */}

          <li>
            <a tabIndex={4} href={void 0} className={"text-blue " + ((!CART_COUNT || CART_COUNT <= 0) ? 'link-disabled' : '')}
              onClick={() => { window.print(); }}>
              <img src={print} alt="Print" />
              <span>Print </span>
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default CartTools;
